{
  "version": 1,
  "asset_id": "51e9d37c-8333-482f-be6e-688c6fd160eb",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/51e9d37c-8333-482f-be6e-688c6fd160eb/buyukcekmece-isyeri-6.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/51e9d37c-8333-482f-be6e-688c6fd160eb/buyukcekmece-isyeri-6.jpg",
  "original_filename": "buyukcekmece-isyeri-6.jpg",
  "size": 624250,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T07:24:30Z"
}
